import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { ItemFocusWhen, useSetItemsFocusWhenMutation } from "sprout-graphql";
import { BookmarkBorder, PushPinOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import PostPageHeaderCancellableButton from "./PostPageHeaderCancellableButton";
const PostPageHeaderFocusWhenButton = (props)=>{
    const { focusWhen , postId  } = props;
    const isFocusNow = focusWhen === ItemFocusWhen.Now;
    const [setItemsFocusWhen] = useSetItemsFocusWhenMutation();
    const showSnackbar = useSnackbar();
    const setDone = useCallback(()=>{
        setItemsFocusWhen({
            variables: {
                userItemPreferences: [
                    postId
                ].map((itemId)=>({
                        itemId,
                        focusWhen: null
                    }))
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        postId,
        setItemsFocusWhen,
        showSnackbar
    ]);
    return /*#__PURE__*/ _jsx(PostPageHeaderCancellableButton, {
        to: `/${isFocusNow ? "today" : "bookmarks"}`,
        icon: /*#__PURE__*/ _jsx(Flex, {
            color: isFocusNow ? "#fccc03" : "#ff9300",
            as: isFocusNow ? PushPinOutlined : BookmarkBorder
        }),
        label: isFocusNow ? "Pinned to Daily" : "Bookmarked",
        onClick: setDone
    });
};
export default PostPageHeaderFocusWhenButton;
